export const backend = process.env.REACT_APP_BACKEND;
// export const backend = "http://localhost:8080/";
export const frontend = process.env.REACT_APP_FRONTEND;
// export const frontend = "http://localhost:3000/";

export const S3Bucket = "https://host-sonder.s3.us-west-2.amazonaws.com/";